import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleRisquesIAPanorama() {
  return (
    <BlogArticleLayout
      tag="IA & Cybersécurité"
      title="Risques cyber liés à l'intelligence artificielle : le panorama"
      date="17 novembre 2026"
      ctaTitle="Intégrez ces risques dans votre diagnostic"
      ctaText="Le diagnostic identifie lesquels de ces risques concernent réellement votre entreprise, selon votre usage de l'IA."
    >
      <p style={s.intro}>
        L'intelligence artificielle introduit des risques cybersécurité qui n'existaient pas, ou peu, avant
        sa généralisation dans les outils professionnels. Voici les principales familles à connaître, chacune
        détaillée dans un article dédié.
      </p>

      <h2 style={s.h2}>Les attaques ciblant directement les systèmes d'IA</h2>
      <p>
        Un modèle d'IA peut être attaqué comme n'importe quel système informatique, mais avec des méthodes
        spécifiques — voir notre article
        {' '}<Link to="/blog/attaques-systemes-ia" style={s.link}>sur les attaques contre les systèmes d'IA</Link>.
      </p>

      <h2 style={s.h2}>La manipulation des instructions (prompt injection)</h2>
      <p>
        Une faille propre aux systèmes basés sur des instructions en langage naturel, qui permet de détourner
        leur comportement — voir notre article
        {' '}<Link to="/blog/prompt-injection-comprendre-proteger" style={s.link}>dédié à la prompt injection</Link>.
      </p>

      <h2 style={s.h2}>La fuite de données via des systèmes mal configurés</h2>
      <p>
        Au-delà des usages individuels de ChatGPT, des systèmes d'IA intégrés à vos processus peuvent
        eux-mêmes devenir un point de fuite — voir notre article
        {' '}<Link to="/blog/fuite-donnees-systemes-ia" style={s.link}>sur la fuite de données via les systèmes d'IA</Link>.
      </p>

      <h2 style={s.h2}>La dépendance aux fournisseurs et aux API externes</h2>
      <p>
        La plupart des entreprises n'entraînent pas leurs propres modèles : elles s'appuient sur des
        fournisseurs et des API tierces, ce qui déplace une partie du risque vers la chaîne
        d'approvisionnement — voir nos articles sur la
        {' '}<Link to="/blog/gestion-fournisseurs-ia" style={s.link}>gestion des fournisseurs IA</Link>{' '}
        et la
        {' '}<Link to="/blog/securite-api-modeles-ia" style={s.link}>sécurité des API et des modèles</Link>.
      </p>

      <h2 style={s.h2}>Les risques liés aux données elles-mêmes</h2>
      <p>
        Les données utilisées pour entraîner, personnaliser ou alimenter un système d'IA posent leurs propres
        questions de confidentialité et de conformité — voir notre article
        {' '}<Link to="/blog/risques-donnees-ia-entreprise" style={s.link}>sur les risques liés aux données utilisées par les IA</Link>.
      </p>

      <h2 style={s.h2}>Ce panorama n'est pas une raison de renoncer à l'IA</h2>
      <p>
        Ces risques ne sont pas une raison de renoncer aux bénéfices de l'IA, mais un rappel qu'elle doit être
        intégrée dans votre démarche cybersécurité globale plutôt que déployée sans cadre. Voir notre
        {' '}<Link to="/blog/ia-risque-cybersecurite-entreprise" style={s.link}>guide complet sur l'IA comme risque cybersécurité</Link>{' '}
        pour la vue d'ensemble.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleRisquesIAPanorama;
